import React, { Component } from 'react';
import ResponsiveTable from 'Components/ResponsiveTable';
import Dropdown from 'Components/Dropdown';
import { TAT_UNITS } from 'Constants/commonConstants';
import { ReactComponent as TrashIcon } from 'Icons/trash.svg';
import Input from 'Components/Input';
import { DateRangePicker, SingleDatePicker } from 'react-dates';
import Moment from 'moment';
import TimePicker from 'rc-time-picker';
import Upload from 'Components/Upload';
import {v4 as uuidv4} from 'uuid';
import Select from 'react-select';
import { connect } from 'react-redux';
import { GET_PROCUREMENT_LPP_DETAILS } from 'Constants/actionConstants';
import Cx from 'classnames';

const TRIP_TYPE = "trip";

class Procurement extends Component {
    constructor(props) {
        super(props);
        this.rfqDetails = props.rfq.rfqDetails;
        this.rfq = props.rfq;
        this.state = {
            rfq: props.rfq,
            data: [],
            templateName: '',
            selectedTransporters: [],
            isChange: true
        }
        this.viewMode = props.viewMode;
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.procurementList.length > 0 && nextProps.data !== nextProps.procurementList && this.state.isChange) {
            this.setState({
                data: nextProps.procurementList,
                isChange: false
            }, () => this.props.onChangeWarehouseTrips(this.state.data));
        }   
    }

    onAddItem = (index, label) => {
        const { data } = this.state;
        data[index][label][Object.keys(data[index][label]).length] = {
            "": []
        }
        this.setState({ data });
    }

    onDeleteItem = (index, label, itemIndex) => {
        const { data } = this.state;
        delete data[index][label][itemIndex]
        this.setState({ data });
    }

    onAddSubItem = (index, label, subItemIndex, subItem) => {
        const { data } = this.state;
        data[index][label][subItemIndex][subItem].push({
            description: '',
            quantity: '',
            cost: '',
            deprication_period: '',
            remarks: ''
        });
        this.setState({ data });    
    }

   
    changeRFQName = (e) => {
        if (this.viewMode) {
           return;
        }
        let val = e.target.value;
        const { rfq } = this.state;
        this.rfq.rfqDetails.setName(val);
        this.setState({
            rfq: this.rfq
        })
        this.props.onChange();
     }

    onChange = (file)=> {
        this.props.uploadDocument(file);
    }

    handleContractNotes = (e) => {
        const { rfq } = this.state;
        this.rfq.rfqDetails.contractNote = e.target.value;
        this.rfq.rfqDetails.setContractNote(e.target.value);
		this.setState({ rfq:  this.rfq });
        this.props.onChange();
    }

    onSelect = (value, name)=> {
        if(this.viewMode || (this.viewType === TRIP_TYPE && (name==="paymentCycle" || name==="pricingBasis"))) {
            return;
        }
        if(name === 'serviceModes') {
            this.rfq.rfqDetails['setProcurement' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        } else if(name === 'deliveryDays') {
            this.rfq.setDeliveryDays({
                unit: value.value,
                name: value.name,
                value: (this.rfq.deliveryDays || {}).value
            })
        } else {
            this.rfq.biddingDetails['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value, 8);
        }
        this.setState({
            rfq: this.rfq
        })
        this.props.onChange();
    }

    onChangeProcurement = (e) => {
        if(this.viewMode) {
            return;
        }
        
        const name = e.target.name;
        const value = e.target.value;
        if(name === 'contactPersonNumberAtSite' && value.length > 10) {
            return;
        }
        if(name === 'tatValue') {
            this.rfq.biddingDetails['set' + name.substr(0,1).toUpperCase() + name.slice(1) ](value);
        } else if(name === 'deliveryDays') {
            this.rfq.setDeliveryDays({
                unit: (this.rfq.deliveryDays || {}).value,
                name: (this.rfq.deliveryDays || {}).name,
                value: value
            })
        } else {
            if(['approvedBudget', 'consumeBudget'].includes(name) && value < 0) {
                return;
            }
            this.rfq.setProcurementDetails(value, name);
            if(['approvedBudget', 'consumeBudget'].includes(name)) {
                const amount = this.rfq.approvedBudget ? Number(this.rfq.approvedBudget || 0) - Number(this.rfq.consumeBudget || 0) : 0;
                this.rfq.setProcurementDetails(amount, 'balanceToConsume');
            }   
        }
        this.setState({
            rfq: this.rfq
        })
        this.props.onChange();
    }

    validateSpecialCases = (e) => {
        ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
    }

    getGeneralParticulars = () => {
        const { data } = this.state;
        const { vendorWithMaterialCode, tripsCount } = this.props;
        return (
            <>
            <div>
                <div className="mb-10 fBold fs-20 wt-400 header-medium-color inBlock tCenter">{`Material Details ${data ? `(${data.length})` : ''}`}</div>
                <div className="mr-20 wt-600 inBlock">
                    <div className="fBold fs-16 mb-5 header-medium-color tCenter">
                        {'Material Code'}
                    </div>
                    <Select
                        isMulti
                        options={vendorWithMaterialCode && [...new Map(vendorWithMaterialCode.map(item => [item['sap_material_code'], item])).values()]}
                        className="mb-20"
                        placeholder="Select Branch"
                        getOptionLabel={(option) => option.sap_material_code}
                        getOptionValue={(option) => option.sap_material_code}
                        value={(this.state.data || []).length > 0 && [...new Map(this.state.data.map(item =>
                            [item['sap_material_code'], item])).values()]}
                        onChange={(option) => { 
                            const { dispatch } = this.props;
                            const selectedMaterial = (option || []).map(el => el.sap_material_code);
                            const filteredData = vendorWithMaterialCode.filter(el => selectedMaterial.includes(el.sap_material_code));
                            const fData = []
                            filteredData.map(el => {
                                const findData = this.state.data.find(mData => mData.sap_material_code === el.sap_material_code);
                                if(!findData) {
                                    fData.push(el);
                                }
                            });
                            let resultentData = this.state.data.filter(el => selectedMaterial.includes(el.sap_material_code));
                            if(filteredData.length === 0){
                                this.setState({
                                    selectedOption: option,
                                    data: filteredData
                                }, () => this.props.onChangeWarehouseTrips(this.state.data))
                            } else {
                                dispatch({
                                    type: GET_PROCUREMENT_LPP_DETAILS,
                                    data: {
                                        trips: fData
                                    },
                                    onSuccess: (result) => {
                                        this.setState({
                                            selectedOption: option,
                                            data: [
                                                ...resultentData,
                                                ...result
                                            ]
                                        }, () => this.props.onChangeWarehouseTrips(this.state.data))
                                    }
                                })
                            }
                            // this.setState({
                            //     selectedOption: option,
                            //     data: vendorWithMaterialCode.filter(el => selectedMaterial.includes(el.sap_material_code))
                            // }, () => this.props.onChangeWarehouseTrips(this.state.data))
                        }}
                    />
                </div>
            </div>
            {(data.length > 0) && <ResponsiveTable className="courier-table pt-10 ph-10 pb-10 procurement-trip-table">
                <table cellpadding="0" cellspacing="0" className="col-1">
                    <thead>
                        <tr>
                            <th>Sl No.</th>
                            <th>Material Code</th>
                            <th>Material Desc.</th>
                            <th>UOM</th>
                            <th width="100">Total Estimated Qty</th>
                            <th width="100">Quantity Prior to this PR</th>
                            <th width="100">Quantity Proposed Now</th>
                            <th width="100">Quantity Balance to Procure</th>
                            <th width="100">LPP</th>
                            <th width="100">Ceiling Price <span className='error-color fs-18'>*</span></th>
                            <th>Remarks</th>
                            <th>SAP Vendor Code</th>
                            <th>Vendor</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((val, valIndex) => (
                        <>
                            {(val.vendor_name || []).map((vendor, vIndex) => (
                            <tr>
                                {vIndex === 0 &&
                                <>
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>{valIndex + 1}</td> 
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>{val.sap_material_code}</td>
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>{val.material_code_description}</td>
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>{val.uom}</td>
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>
                                    <Input 
                                        type="number"
                                        value={val.total_estimated_qty || ''} 
                                        name="total_estimated_qty" 
                                        placeHolder="Eg.10"
                                        onChange={(e) => {
                                            const { data } = this.state;
                                            data[valIndex]['total_estimated_qty'] = Number(e.target.value || 0);
                                            this.setState({ data });
                                            this.props.onChangeWarehouseTrips(data);
                                        }}
                                        className={'mr-5 inBlock'}
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>
                                    <Input 
                                        type="number"
                                        value={val.qty_prior_to_pr || ''} 
                                        name="qty_prior_to_pr" 
                                        placeHolder="Eg.6"
                                        onChange={(e) => {
                                            const { data } = this.state;
                                            data[valIndex]['qty_prior_to_pr'] = Number(e.target.value || 0);
                                            data[valIndex]['qty_proposed_now'] =  Number(data[valIndex]['total_estimated_qty'] || 0) - Number(data[valIndex]['qty_prior_to_pr'] || 0)
                                            this.setState({ data });
                                            this.props.onChangeWarehouseTrips(data);
                                        }}
                                        className={'mr-5 inBlock'}
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>
                                    {val.qty_proposed_now || '-'}
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>
                                    <Input 
                                        type="number"
                                        value={val.qty_balance_to_procure || ''} 
                                        name="qty_balance_to_procure" 
                                        placeHolder="Eg.0"
                                        onChange={(e) => {
                                            const { data } = this.state;
                                            data[valIndex]['qty_balance_to_procure'] = Number(e.target.value || 0);
                                            this.setState({ data });
                                            this.props.onChangeWarehouseTrips(data);
                                        }}
                                        className={'mr-5 inBlock'}
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>
                                    {val.lpp || '-'}
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>
                                    <Input 
                                        type="number"
                                        value={val.ceiling_price || ''} 
                                        name="ceiling_price" 
                                        placeHolder="Eg.1000"
                                        onChange={(e) => {
                                            const { data } = this.state;
                                            data[valIndex]['ceiling_price'] = e.target.value;
                                            this.setState({ data });
                                            this.props.onChangeWarehouseTrips(data);
                                        }}
                                        className={'mr-5 inBlock'}
                                    />
                                </td>
                                <td style={{ 'borderBottom': '1px solid grey'}} rowSpan={val.vendor_name.length}>
                                    <Input 
                                        value={val.remarks || ''} 
                                        name="remarks" 
                                        placeHolder="Remarks"
                                        onChange={(e) => {
                                            const { data } = this.state;
                                            data[valIndex]['remarks'] = e.target.value;
                                            this.setState({ data });
                                            this.props.onChangeWarehouseTrips(data);
                                        }}
                                        className={'mr-5 wt-50 inBlock'}
                                    />
                                </td>
                                </>}
                                <td style={{ 'borderBottom': '1px solid grey'}}>{vendor.sap_code}</td>
                                <td style={{ 'borderBottom': '1px solid grey'}}>{vendor.name}</td>
                                <td style={{ 'borderBottom': '1px solid grey'}}>
                                    {val.vendor_name.length > 1 && <TrashIcon 
                                        width="15" 
                                        height="15" 
                                        className="error-color fs-24 fBold ml-5 curP"
                                        fill="red"
                                        onClick={() => {
                                            const { data } = this.state;
                                            data[valIndex]['vendor_name'].splice(vIndex, 1);
                                            this.setState({ data });
                                            this.props.onChangeWarehouseTrips(data);
                                        }}
                                    />}
                                </td>
                                {vIndex === 0 && <td style={{ 'borderBottom': '1px solid grey', 'borderRight': '1px solid grey'}} rowSpan={val.vendor_name.length}>
                                    <TrashIcon 
                                        width="15" 
                                        height="15" 
                                        className="error-color fs-24 fBold ml-5 curP"
                                        fill="red"
                                        onClick={() => {
                                            const { data } = this.state;
                                            data[valIndex]['vendor_name'].splice(vIndex, 1);
                                            this.setState({ data });
                                            this.props.onChangeWarehouseTrips(data);
                                        }}
                                    />
                                </td>}
                            </tr>))}
                        </>))}
                    </tbody>
                </table>
            </ResponsiveTable>}
            </>
        )
    }
 
    render() {
        const { data, rfq, templateName, showTransporters, selectedTransporters } = this.state;
        const { rfqDetails } = rfq;
        const { systemTime, documents, warehouseTemplate, groups, vendorWithMaterialCode, paymentTerms, serviceModes, activeView } = this.props;
        return (
            <>
                    {[1,3].includes(activeView) && 
                    <>
                    <div className="box-shadow col-1 pv-10 ph-5 mt-20 mt-80 pr">
                    <div className="box-shadow col-1 pv-10 ph-20 warehouse-rfq">
                    { activeView === 3 && <div className="mb-10 fBold fs-22 tCenter header-medium-color">RFQ Details</div> }
                    <div className="flex flex-between">
                        <div className="mr-20 wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color" >
                            RFQ Name
                            </div>
                            <Input value={rfqDetails.name} onChange={this.changeRFQName} placeholder="Eg: Date And Branch Name" className="mb-10"/>
                        </div>
                        <div className="mr-20">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                            Contract Tenure <span className="error-color fs-18">*</span>
                            </div>
                            <div className="mb-10" >
                            <DateRangePicker
                                startDate={!rfqDetails.contractTenureTo ? Moment(rfqDetails.contractTenureFrom || null) : Moment(rfqDetails.contractTenureFrom)}
                                startDateId="startDate"
                                endDate={rfqDetails.contractTenureTo ? Moment(rfqDetails.contractTenureTo) : null}
                                endDateId="endDate"
                                onDatesChange={({ startDate, endDate }) => {
                                    const { rfq } = this.state;
                                const startDateTime = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : new Date(this.state.startDate).setHours(0, 0, 0, 0)
                                this.rfq.rfqDetails.setContractTenureFrom(startDateTime)
                                const endTime = endDate ? new Date(endDate).setHours(23, 59, 59) : undefined;
                                this.rfq.rfqDetails.setContractTenureTo(endTime ? new Date(endTime).getTime() : this.state.endDate);
                                this.setState({
                                        rfq: this.rfq
                                });
                                this.props.onChange();
                                }}
                                focusedInput={this.state.focusedInput}
                                onFocusChange={focusedInput => this.setState({ focusedInput: true ? focusedInput : null })}
                                displayFormat={'DD MMM YYYY'}
                                noBorder={true}
                                minimumNights={0}
                            />
                            </div>
                        </div>
                        <div className="mr-20">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Bidding From
                            </div>
                            <div className="flex pb-20 mt--1 wt-250">
                                <SingleDatePicker
                                    noBorder={true}
                                    displayFormat={"DD MMM YYYY"}
                                    hideKeyboardShortcutsPanel={true}
                                    placeholder={"Placement Date"}
                                    numberOfMonths={2}
                                    date={Moment(rfq.biddingDetails.from)} 
                                    onDateChange={(from) =>{
                                        if(this.viewMode || this.viewType === TRIP_TYPE) {
                                            return;
                                        }
                                        if(from) {
                                            const date = from.format('YYYY-MM-DD') + ' ' + Moment(rfq.biddingDetails.from).format('HH:mm')
                                            this.rfq.biddingDetails.setFrom(new Date(date).getTime());
                                            if(rfq.bidEndTimeValue > 0) {
                                                this.rfq.biddingDetails.setTo(new Date(date).getTime() + rfq.bidEndTimeValue);
                                            }
                                            this.setState({ rfq: this.rfq });
                                            this.props.onChange()
                                        }
                                    }}
                                    focused={this.state.focusedStart} 
                                    onFocusChange={({ focused }) => this.setState({ focusedStart: (this.viewMode || this.viewType === TRIP_TYPE)?null:focused })} 
                                    isOutsideRange={(date) => date < new Date(systemTime).setHours(0)}
                                    // isOutsideRange={(date) => date < Moment(systemTime).setHours(0)}
                                />
                                <TimePicker
                                    showSecond={false}
                                    value={Moment(rfq.biddingDetails.from)}
                                    className="ht-40 wt-150 border-status-bar br-5"
                                    onChange={(from) =>{
                                        if(this.viewMode || this.viewType === TRIP_TYPE) {
                                            return;
                                        }
                                        const date = Moment(rfq.biddingDetails.from).format('YYYY-MM-DD') + ' ' + from.format('HH:mm')
                                        this.rfq.biddingDetails.setFrom(new Date(date).getTime());
                                        if(rfq.bidEndTimeValue > 0) {
                                            this.rfq.biddingDetails.setTo(new Date(date).getTime() + rfq.bidEndTimeValue);
                                        }
                                        this.setState({ rfq: this.rfq });
                                        this.props.onChange()
                                    }}
                                    // minTime={new Date()}
                                    minTime={Moment(systemTime)}
                                    format={'h:mm a'}
                                    use12Hours
                                    inputReadOnly
                                    disabled={this.viewMode || this.viewType===TRIP_TYPE}
                                />
                            </div>
                            {(Moment(rfq.biddingDetails.from) > Moment(new Date(this.props.systemTime))) &&
                            <span className="error-color fs-14 fSemibold op-7 ml-5">Bidding Date Should Be From Current Date</span>}
                        </div>
                        <div>
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Bidding To <span className="error-color fs-18">*</span>
                            </div>
                            <div className="flex pb-20 wt-250">
                                <SingleDatePicker
                                    noBorder={true}
                                    displayFormat={"DD MMM YYYY"}
                                    hideKeyboardShortcutsPanel={true}
                                    placeholder={"Bidding To"}
                                    numberOfMonths={2}
                                    date={rfq.biddingDetails.to?Moment(rfq.biddingDetails.to):null} 
                                    onDateChange={(from) =>{
                                        if(this.viewMode || this.viewType === TRIP_TYPE) {
                                            return;
                                        }
                                        // const date = from.format('YYYY-MM-DD') + ' ' + Moment(this.biddingDetails.to?this.biddingDetails.to:new Date().getTime()).format('HH:mm')
                                        if(from) {
                                            const date = from.format('YYYY-MM-DD') + ' ' + Moment(rfq.biddingDetails.to?rfq.biddingDetails.to: systemTime).format('HH:mm')
                                            this.rfq.biddingDetails.setTo(new Date(date).getTime());
                                            this.setState({ rfq: this.rfq });
                                            this.props.onChange()
                                        }
                                    }}
                                    focused={this.state.focusedEnd} 
                                    onFocusChange={({ focused }) => this.setState({ focusedEnd: (this.viewMode || this.viewType === TRIP_TYPE)?null:focused })}
                                    // isOutsideRange={(date) => this.checkIsOutside(date, rfqServiceType)}
                                />
                                <TimePicker
                                    showSecond={false}
                                    value={rfq.biddingDetails.to?Moment(rfq.biddingDetails.to): null}
                                    className="ht-40 wt-150 border-status-bar br-5"
                                    onChange={(to) =>{
                                        if(this.viewMode || this.viewType === TRIP_TYPE || !rfq.biddingDetails.to) {
                                            return;
                                        }
                                        const date = Moment(rfq.biddingDetails.to).format('YYYY-MM-DD') + ' ' + to.format('HH:mm')
                                        this.rfq.biddingDetails.setTo(new Date(date).getTime());
                                        this.setState({ rfq: this.rfq });
                                        this.props.onChange()
                                    }}
                                    // minTime={new Date()}
                                    minTime={Moment(systemTime)}
                                    format={'h:mm a'}
                                    use12Hours
                                    inputReadOnly
                                    disabled={this.viewMode || !rfq.biddingDetails.to || this.viewType===TRIP_TYPE}
                                />
                            </div>
                            {/* {
                            //  (this.state.biddingDetails.to > Moment(new Date()).add(6, 'days').valueOf()) &&
                                (rfq.biddingDetails.to > Moment(systemTime).add(6, 'days').valueOf()) &&  
                                <span className="error-color fs-14 fSemibold op-7 ml-5">Bidding To Time For Container Service Type Should Be Between 7 Days</span>} */}
                        </div>
                    </div>
                    <div className="flex flex-between mb-20">
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Delivery Days <span className="error-color fs-18">*</span>
                            </div>
                            <div className="flex">
                                <Input onChange={this.onChangeProcurement} value={(rfq.deliveryDays || {}).value} name="deliveryDays" className="mr-5 wt-100"/>
                                <Dropdown 
                                items={[...TAT_UNITS]} 
                                selectedItem={TAT_UNITS.find(tatUnit=>{return rfq.deliveryDays.unit === tatUnit.value})}
                                name="deliveryDays"
                                displayKey="name" 
                                label="Select Unit"
                                className="wt-150 ht-40" 
                                onSelect={this.onSelect}
                                />
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Payment Terms <span className="error-color fs-18">*</span>
                            </div>
                            <div>
                                <Dropdown 
                                items={[...paymentTerms]} 
                                selectedItem={paymentTerms.find(pTerms=>{return rfq.biddingDetails.paymentTerms === pTerms.id})}
                                name="paymentTerms"
                                displayKey="name" 
                                label="Select Unit"
                                className="wt-260 ht-40" 
                                onSelect={this.onSelect}
                                />
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Mode of Dispatch <span className="error-color fs-18">*</span>
                            </div>
                            <div>
                                <Dropdown 
                                items={[...serviceModes]} 
                                selectedItem={serviceModes.find(sMode=>{return rfq.rfqDetails.serviceModeName === sMode.name})}
                                name="serviceModes"
                                displayKey="name" 
                                label="Select Unit"
                                className="wt-260 ht-40 mr-20" 
                                onSelect={this.onSelect}
                                />
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Dispatch Destination
                            </div>
                            <div>
                                <Input onChange={this.onChangeProcurement} value={rfq.dispatchDestination} name="dispatchDestination" className="mr-5 wt-250"/>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-between">
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Contact Person At Site 
                            </div>
                            <div>
                                <Input onChange={this.onChangeProcurement} value={rfq.contactPersonAtSite} name="contactPersonAtSite" className="mr-5 wt-250"/>
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Contact Person Phone Number At Site
                            </div>
                            <div>
                                <Input type="number" onKeyDown={(e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()} onChange={this.onChangeProcurement} value={rfq.contactPersonNumberAtSite} name="contactPersonNumberAtSite" className="mr-5 wt-250"/>
                            </div>
                        </div>
                        <div className={'wt-250'}>
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                {'T & C And Other Documents'}
                            </div>
                            <div>
                            {!this.viewMode && <Upload onChange={this.onChange} value="Upload File" fileSize={10}>
                                <button className="border-theme wt-250 ht-40 bg-white theme-color fBold fs-16 br-20">
                                    {/* <PlusIcon className="mr-10"/> */}
                                    Upload New Document
                                </button>
                            </Upload>
                            }
                            </div>
                            {
                                documents.map((document, index)=> {
                                    return (
                                        <div className="tCenter mt-3">
                                        <div 
                                            key={uuidv4()} className="pr wt-150 mr-50 curP mb-40" 
                                            onClick={()=>this.props.downloadUploadedFile(document.name)} 
                                            // href={document.url} 
                                            >
                                            {/* <CloseIcon className="pa t-0 r-0 curP" onClick={this.props.removeDocument.bind(this, index, this.uploadedFile)}/> */}
                                            {/* <img src={Preview} alt={document.name} className="wt-150 ht-150"/> */}
                                            <span className="fSemibold fs-14 theme-color">{document.name}</span>
                                            <TrashIcon 
                                                width="15" 
                                                height="15" 
                                                className="error-color fs-24 fBold ml-5 curP"
                                                fill="red"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    this.props.removeDocument(index)
                                                }}
                                            />
                                        </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                {'Contract Note'}
                            </div>
                            <div className="fBold fs-14 caption-color pl-5 mb-20 tCenter">
                                {!this.viewMode &&
                                    <textarea 
                                        className=""
                                        style={{ width: '100%',  height: '40px' }}
                                        name="Contract Notes"
                                        placeholder="Contract Notes"
                                        value={rfq.contractNote}
                                        onChange={this.handleContractNotes}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                    <div  className="flex flex-between mb-20">
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Project No.
                            </div>
                            <div>
                                <Input onChange={this.onChangeProcurement} value={rfq.projectNumber} name="projectNumber" className="mr-5 wt-250"/>
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Site
                            </div>
                            <div>
                                <Input onChange={this.onChangeProcurement} value={rfq.site} name="site" className="mr-5 wt-250"/>
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Requisition No.
                            </div>
                            <div>
                                <Input onChange={this.onChangeProcurement} readOnly={true} value={rfq.requisitionNumber} name="requisitionNumber" className="mr-5 wt-250 disabled"/>
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Date
                            </div>
                            <div>
                                <SingleDatePicker
                                    noBorder={true}
                                    displayFormat={"DD MMM YYYY"}
                                    hideKeyboardShortcutsPanel={true}
                                    placeholder={"Date"}
                                    numberOfMonths={2}
                                    date={Moment(rfq.prDate)} 
                                    onDateChange={(from) =>{
                                        if(this.viewMode || this.viewType === TRIP_TYPE) {
                                            return;
                                        }
                                        const date = from ? from.format('YYYY-MM-DD') + ' ' + Moment(rfq.prDate).format('HH:mm') : null
                                        this.rfq.setPRDate(new Date(date).getTime());
                                        this.setState({ rfq: this.rfq });
                                        this.props.onChange()
                                    }}
                                    focused={this.state.prDate} 
                                    onFocusChange={({ focused }) => this.setState({ prDate: (this.viewMode || this.viewType === TRIP_TYPE)?null:focused })} 
                                    isOutsideRange={(date) => date < new Date(systemTime).setHours(0)}
                                    // isOutsideRange={(date) => date < Moment(systemTime).setHours(0)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-between mb-20">
                        {/* <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Country
                            </div>
                            <div>
                                <Input onChange={this.onChangeProcurement} value={rfq.country} name="country" className="mr-5 wt-250"/>
                            </div>
                        </div> */}
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                WBS
                            </div>
                            <div>
                                <Input onChange={this.onChangeProcurement} value={rfq.wbs} name="wbs" className="mr-5 wt-250"/>
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Activity
                            </div>
                            <div>
                                <Input onChange={this.onChangeProcurement} value={rfq.activity} name="activity" className="mr-5 wt-250"/>
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Approval Note No.
                            </div>
                            <div>
                                <Input onChange={this.onChangeProcurement} value={rfq.approvalNoteNo} name="approvalNoteNo" className="mr-5 wt-250"/>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-between mb-50">
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Approved Budget
                            </div>
                            <div>
                                <Input type="number" onKeyDown={this.validateSpecialCases} onChange={this.onChangeProcurement} value={rfq.approvedBudget} name="approvedBudget" className="mr-5 wt-250"/>
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Consume Budget
                            </div>
                            <div>
                                <Input type="number" onKeyDown={this.validateSpecialCases} onChange={this.onChangeProcurement} value={rfq.consumeBudget} name="consumeBudget" className="mr-5 wt-250"/>
                            </div>
                        </div>
                        <div className="wt-250">
                            <div className="fBold fs-16 mb-5 header-medium-color">
                                Balance To Consume
                            </div>
                            <div>
                                <Input type="number" onKeyDown={this.validateSpecialCases} onChange={this.onChangeProcurement} readOnly={true} value={rfq.balanceToConsume} name="balanceToConsume" className="mr-5 wt-250 disabled"/>
                            </div>
                        </div>
                        <div className="wt-250"></div>
                    </div>
                    </div>
                    </div>
                    </>}
                    {[2,3].includes(activeView) && 
                        <>
                        <div className={Cx("box-shadow col-1 pv-10 ph-5 pr", {
                            'mt-10': activeView === 3,
                            'mt-80': activeView !== 3
                        })}>
                            <div className="box-shadow col-1 pv-10 ph-5 warehouse-rfq">
                                {this.getGeneralParticulars()}
                            </div>
                        </div>
                        </>
                    }
            </>
        )
    }
}

export default connect()(Procurement);
